<template>
    <layout-main :banner="banner" subtitle="医院资产定位系统">
        <template v-slot:content>
            <p class="text">医院资产定位系统是围绕RFID技术推出的应用，定位系统解决方案基于第二代红外和有源RFID组合技术，主要应用包括远距离识别的资产管理（医院资产设备管理系统），一卡通智能医院、中距离门禁等。产品配合灵活，可根据不同的场合搭配不同的设备以及应用方案，以满足院方的管理需求。</p>
            <img src="@/assets/beLost/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 集成迪孚实时定义技术和监护人安全解决方案</p>
            <p class="text weight">· 兼容第二代红外技术的临床级定位应用程序</p>
            <p class="text weight">· 可实时显示指定区域的设备分布情况，实时显示医院设备位置及状态</p>
            <p class="text weight">· 显示区域信息，实时更新信息，包括区域历史信息记录查询</p>
            <p class="text weight">· 可以对设备进行实时定位和异常报警</p>
            <p class="text weight">· 标签采用人体工程学设计体积小，重量轻</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/assets/banner.png'
export default {
  components: {
      layoutMain,
      
  },
  data () {
      return {
          banner: banner
      }
  }
}
</script>
<style lang="scss" scoped>
.weight{
    font-weight: 600;
    line-height: 3 !important;
}
.title{ 
    text-indent: 1.5em;
    font-size: 25px;
    text-align: left;
    margin: 20px 0;
}
.text{
    line-height: 2;
}
.image1{
    width: 100%;
    margin: 50px 0;
}
</style>
